import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/view/index.vue'
import chainPage from '@/view/chainPage/chainPage.vue';
Vue.use(VueRouter);

const routes = [
    {
        path:'/',
        redirect:'/iesoo/bindStore'
    },
    {
        path: '/iesoo',
        name: 'iesoo',
        redirect: '/iesoo/bindStore',
        component:Home,
        children: [
            {
                path: 'bindStore',
                name: 'bindStore',
                meta: { title: '下载页'},
                component: () => import('@/view/iesoo/bindStore.vue'),
            }
        ]
    },
    {
        path: '/chainPage',
        name: 'chainPage',
        component:chainPage,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes
})
export default router